<template>
  <div class="classManage">
    <el-card>
      <div v-auth="'classManage_/classInfoPhase/pageList'">
        <el-row :gutter="20" style="margin-bottom: 10px">
          <el-col :sm="12" :md="5" :lg="5">
            <el-cascader
              collapse-tags
              style="width: 100%"
              v-model="searchForm.campusId"
              :show-all-levels="false"
              :props="campusTreeProps"
              placeholder="请选择所属校区"
              :options="campusList"
              clearable
              @change="campusIdChange(searchForm.campusId)"
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-cascader
              style="width: 100%"
              clearable
              v-model="searchForm.courseIds"
              :show-all-levels="false"
              :props="subjectTreeProp"
              placeholder="请选择所属科目"
              :options="ClassInfoTree"
              @change="subjectIdChange()"
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.name"
              placeholder="班级期数名称"
              clearable
              @blur="classManageSearch.pageNumber = 1"
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.headTeacher"
              placeholder="搜索班主任"
              clearable
              @blur="classManageSearch.pageNumber = 1"
            ></el-input>
          </el-col>
          <el-col
            :sm="12"
            :md="4"
            :lg="4"
            style="float: right"
            v-if="isOpenSearch == false"
          >
            <el-button
              type="default"
              style="float: right; margin-left: 5px"
              icon="el-icon-arrow-down"
              @click="isOpenSearch = true"
              >展开</el-button
            >
            <el-button
              type="primary"
              style="float: right"
              icon="el-icon-search"
              @click="(classManageSearch.pageNumber = 1), pageList()"
              >查询</el-button
            >
          </el-col>
          <el-col :sm="12" :md="4" :lg="4" v-else>
            <el-date-picker
              format="yyyy-MM"
              value-format="yyyy-MM"
              style="width: 100%"
              @change="yearMonthChange"
              v-model="searchForm.yearMonth"
              type="month"
              placeholder="选择月份"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px" v-if="isOpenSearch == true">
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.classroomName"
              placeholder="教室"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.teacherName"
              placeholder="授课老师"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-date-picker
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @change="classStartDateChange"
              v-model="classStartRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-col>
          <el-col :sm="12" :md="6" :lg="6">
            <div style="display: flex">
              <el-select
                collapse-tags
                clearable
                v-model="searchForm.weekdays"
                multiple
                placeholder="请选择"
                style="margin-right: 5px"
              >
                <el-option label="星期一" value="2"></el-option>
                <el-option label="星期二" value="3"></el-option>
                <el-option label="星期三" value="4"></el-option>
                <el-option label="星期四" value="5"></el-option>
                <el-option label="星期五" value="6"></el-option>
                <el-option label="星期六" value="7"></el-option>
                <el-option label="星期日" value="1"></el-option>
              </el-select>
              <el-select
                collapse-tags
                clearable
                v-model="searchForm.periods"
                multiple
                placeholder="请选择"
                style="margin-right: 5px"
              >
                <el-option
                  v-for="(item, index) in classStartPeriodList"
                  :key="index"
                  :label="item.beginTime + '-' + item.endTime"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <el-time-picker is-range v-model="searchForm.timeRange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
              </el-time-picker> -->
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px" v-if="isOpenSearch == true">
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.minNumber"
              placeholder="标准开班人"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-input
              v-model="searchForm.qqGroup"
              placeholder="微信,QQ群号"
              clearable
              @blur="classManageSearch.pageNumber = 1"
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="6" :lg="6">
            <div style="display: flex">
              <el-select
                clearable
                v-model="searchForm.classInfoPhaseState"
                placeholder="报名/上课进度"
              >
                <el-option label="已结课" value="已结课"></el-option>
                <el-option label="未结课" value="未结课"></el-option>
              </el-select>
              <el-button
                style="margin-left: 5px"
                type="primary"
                icon="el-icon-search"
                @click="(classManageSearch.pageNumber = 1), pageList()"
                >查询</el-button
              >
              <el-button
                type="default"
                style="margin-left: 5px"
                icon="el-icon-arrow-up"
                @click="isOpenSearch = false"
                >收起</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="classManage-classList">
        <el-button
          v-auth="'classManage_/classInfoPhase/addClassInfoPhase'"
          type="primary"
          @click="
            getCampusList(), addCourse();
            getSubjectTreeList();
          "
          icon="el-icon-plus"
          >添加班级</el-button
        >
        <el-button type="primary" @click="goAddClass()" v-auth="'classManage_addClass'"
          >批量排课</el-button
        >
        <el-button
          v-auth="'classManage_classSchedule'"
          type="primary"
          style="float: right"
          @click="goClassSchedule()"
          >现有课程表</el-button
        >
      </div>
      <el-table
        v-auth="'classManage_/classInfoPhase/pageList'"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        ref="multipleTable"
        :data="classManageList.records"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="yearMonth"
          label="月份"
          align="center"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="campusName"
          label="所属校区"
          align="center"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="subjectName"
          label="所属科目"
          align="center"
          show-overflow-tooltip
          width="200"
        ></el-table-column>
        <el-table-column
          prop="operator"
          label="创建人"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="type"
          label="班级类型"
          align="center"
          width="150"
          show-overflow-tooltip
          :render-header="renderSpecNameHeader"
        ></el-table-column>
        <el-table-column
          prop="classroomName"
          label="教室"
          width="150"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          show-overflow-tooltip
          label="开班时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope"
            >{{ scope.row.startDate }}-{{ scope.row.endDate }}</template
          >
        </el-table-column>
        <!-- <el-table-column prop="teacherName" label="授课老师" width="150" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column
          prop="minNumber"
          label="标准开班人"
          width="150"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="headTeacherName"
          label="班主任"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="qqGroup"
          label="微信，QQ群号"
          width="150"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          fixed="right"
          prop="classInfoPhaseState"
          label="报名/上课进度"
          width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phase"
          label="上课信息"
          align="left"
          show-overflow-tooltip
          width="600"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.classInfoList"
              :key="index"
              style="display: block"
            >
              <span>{{ item.courseName }}</span>
              <span style="color: #62afff">{{ item.teacherName }}</span>
              <div
                v-for="(e, i) in item.scheduleRules"
                :key="i"
                style="display: inline-block"
              >
                <span v-if="e.weekday == 1">星期日</span>
                <span v-if="e.weekday == 2">星期一</span>
                <span v-if="e.weekday == 3">星期二</span>
                <span v-if="e.weekday == 4">星期三</span>
                <span v-if="e.weekday == 5">星期四</span>
                <span v-if="e.weekday == 6">星期五</span>
                <span v-if="e.weekday == 7">星期六</span>
                <span> {{ e.period }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope">
            <span style="color: #409eff" @click="editRemark(scope.row)">{{
              scope.row.remark ? scope.row.remark : "添加备注"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="phase"
          label="班级"
          align="center"
          show-overflow-tooltip
          width="280"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="goClassDetail(scope.row)">{{
              scope.row.className
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="phase"
          label="已排课"
          align="center"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.scheduleCourseCount }}/{{ scope.row.totalCourseCount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="phase"
          label="操作"
          align="center"
          show-overflow-tooltip
          width="80"
          v-if="admin == 1"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="delClass(scope.row.id)"
              v-auth="'classManage_/classInfoPhase/deleteClassInfoPhase'"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-auth="'classManage_/classInfoPhase/pageList'"
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px; text-align: left"
        :total="classManageList.total"
        :page-size="classManageList.pageSize"
        :page-sizes="[10, 20, 30, 40]"
        :current-page="classManageList.pageNumber"
        @size-change="classManageSizeChange"
        @current-change="classManageCurrentChange"
      ></el-pagination>
    </el-card>
    <el-dialog
      title="添加班级"
      :visible.sync="classDialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="addForm.campusId"
                :show-all-levels="false"
                :props="campusListProps"
                placeholder="请选择所属校区"
                :options="campusList"
                @change="getTeacherTreeChange(addForm.campusId)"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="班级名称" prop="name">
              <el-input placeholder="请输入班级名称" v-model="addForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属科目" prop="courseIds">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="addForm.courseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目"
                :options="subjectTreeList"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="上课时间" prop="type">
              <el-select
                placeholder="请选择班级类型"
                style="width: 100%"
                v-model="addForm.type"
              >
                <el-option value="平时白班">平时白班</el-option>
                <el-option value="平时晚班">平时晚班</el-option>
                <el-option value="周末白班">周末白班</el-option>
                <el-option value="周末晚班">周末晚班</el-option>
                <el-option value="一三白班">一三白班</el-option>
                <el-option value="一三晚班">一三晚班</el-option>
                <el-option value="三五白班">三五白班</el-option>
                <el-option value="三五晚班">三五晚班</el-option>
                <el-option value="一三五白班">一三五白班</el-option>
                <el-option value="一三五晚班">一三五晚班</el-option>
                <el-option value="一四白班">一四白班</el-option>
                <el-option value="一四晚班">一四晚班</el-option>
                <el-option value="二四白班">二四白班</el-option>
                <el-option value="二四晚班">二四晚班</el-option>
                <el-option value="一二四五六日晚班">一二四五六日晚班</el-option>
                <el-option value="周六班">周六班</el-option>
                <el-option value="周日班">周日班</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="班主任" prop="headTeacherName">
              <el-autocomplete
                class="inline-input"
                style="width: 100%"
                v-model="addForm.headTeacherName"
                :fetch-suggestions="querySearch"
                placeholder="请选择班主任"
                @select="handleSelect"
                clearable
              ></el-autocomplete>

              <!-- <el-select placeholder="请选择班主任" style="width:100%" v-model="addForm.headTeacher">
                <el-option v-for="item in headTeacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="签到距离" prop="signDistance">
              <el-select
                placeholder="请选择签到距离"
                style="width: 100%"
                v-model="addForm.signDistance"
              >
                <el-option value="500">500米</el-option>
                <el-option value="1000">1000米</el-option>
                <el-option value="无签到要求">无签到要求</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="开班人数" prop="maxNumber">
              <el-col :span="11">
                <el-input
                  type="number"
                  v-model="addForm.minNumber"
                  placeholder="请输入最低人数"
                  maxlength="5"
                ></el-input>
              </el-col>
              <el-col class="line" style="text-align: center" :span="2">-</el-col>
              <el-col :span="11">
                <el-input
                  type="number"
                  v-model="addForm.maxNumber"
                  placeholder="请输入最高人数"
                  maxlength="5"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="开班时间" prop="period">
              <el-date-picker
                style="width: 100%"
                v-model="addForm.period"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="QQ群" prop="qqGroup">
              <el-input
                v-model="addForm.qqGroup"
                placeholder="请输入QQ群"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClassInfo" :loading="addClassInfoBlock"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="备注" :visible.sync="remarkModal" width="400px" left>
      <el-form
        ref="remarkForm"
        :model="remarkForm"
        :label-width="formLabelWidth"
        :rules="remarkFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="校区" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
                v-model="remarkForm.remark"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="remarkModal = false">取 消</el-button>
        <el-button type="primary" @click="updateRenarkConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectHeader from "./SelectHeader";
export default {
  data() {
    let validateMin = (rule, value, callback) => {
      if (value < 0 || this.addForm.minNumber < 0) {
        callback("开班人数不能小于0");
      } else {
        callback();
      }
    };
    return {
      // 管理员删除
      admin: "",
      formLabelWidth: "80px",
      classStartRange: [],
      remarkFormRules: {
        remark: {
          required: true,
          message: "请输入备注",
          trigger: "change",
        },
      },
      remarkForm: {
        remark: "",
      },
      remarkModal: false,
      isOpenSearch: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      addClassInfoBlock: false,
      clickTrue: true,
      mousemoveShow: "",
      loading: true,
      formLabelWidth: "70px",
      value: new Date(),
      courseIds: [],
      classInfoPhaseList: [],
      subjectTreeList: [],
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        // checkStrictly: true
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      campusListProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
        // checkStrictly: true
      },
      ClassInfoTree: [],
      multipleSelection: [],
      ChapterProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      activeName: "first",
      classList: {},
      studentList: {},
      classDialogVisible: false,
      campusList: [],
      teacherList: [],
      headTeacherList: [],
      academicTeacherList: [],
      signLogList: [],
      searchForm: {
        campusId: null,
        headTeacher: "",
        courseId: "",
        classInfoPhase: null,
      },
      classManageSearch: {
        pageNumber: 1,
        pageSize: 10,
        headTeacher: null,
        subjectCourseId: "",
      },
      classManageList: {},
      addForm: {
        campusId: [],
        courseIds: [],
        name: "",
        type: "",
        classInfoPhase: "",
        headTeacher: "",
        headTeacherName: "",
        signDistance: "",
        qqGroup: "",
        minNumber: "",
        maxNumber: "",
        teacherIds: "",
        period: [],
        remark: "",
      },
      addFormRules: {
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入班级名称",
            trigger: "blur",
          },
        ],
        courseIds: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change",
          },
        ],
        classInfoPhase: [
          {
            required: true,
            message: "请选择班级期数",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择班级类型",
            trigger: "change",
          },
        ],
        headTeacherName: [
          {
            required: true,
            message: "请选择班主任",
            trigger: "change",
          },
        ],
        signDistance: [
          {
            required: true,
            message: "请选择签到距离",
            trigger: "change",
          },
        ],
        maxNumber: [
          {
            required: true,
            message: "请输入开班人数",
            trigger: "blur",
          },
          {
            validator: validateMin,
            trigger: "blur",
          },
        ],
        period: [
          {
            required: true,
            message: "请选择开班时间",
            trigger: "change",
          },
        ],
        // teacherIds: [
        //   {
        //     required: true,
        //     message: "请选择修改人",
        //     trigger: "change"
        //   }
        // ]
      },
      classStartPeriodList: [],
      clickRowData: {},
    };
  },
  created() {
    this.admin = JSON.parse(localStorage.getItem("user")).admin;
    console.log(this.admin, 789789789);
  },
  computed: {},
  methods: {
    // 删除
    delClass(id) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.classInfoPhase.deleteClass([{ id }]).then((result) => {
          if (result.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            console.log(789);
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    querySearch(queryString, cb) {
      this.headTeacherList.forEach((item) => {
        if (item.campusName) {
          item.value = item.name + "-" + item.campusName;
        } else {
          item.value = item.name;
        }
      });
      var restaurants = this.headTeacherList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // // 调用 callback 返回建议列表的数据
      console.log(466, results);
      cb(results);
    },
    createFilter(queryString) {
      return (restaurants) => {
        return restaurants.value.indexOf(queryString) !== -1;
      };
    },
    handleSelect(val) {
      console.log(470, val);
      this.addForm.headTeacher = val.id;
    },
    updateRenarkConfirm() {
      console.log(this.remarkForm.remark);
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          this.api.campus
            .updateClassRemark({
              id: this.clickRowData.id,
              remark: this.remarkForm.remark,
            })
            .then((res) => {
              if (res.success) {
                this.classManageSearch.pageNumber = 1;
                this.pageList();
                this.remarkForm.remark = "";
              } else {
                this.$message.error(res.message);
              }
              this.remarkModal = false;
            });
        } else {
          return false;
        }
      });
    },
    editRemark(row) {
      this.clickRowData = row;
      this.remarkModal = true;
      this.remarkForm.remark = row.remark || "";
      this.$refs.remarkForm.clearValidate();
    },
    campusIdChange(item) {
      if (item) {
        let length = item.length;
        let index = length;
        this.classManageSearch.campusId = this.searchForm.campusId[index - 1];
        this.getHeadTeacherList(item[index - 1]);
        this.getAcademicTeacherList(item[index - 1]);
        this.searchForm.courseIds = null;
        this.searchForm.classInfoPhase = null;
      } else {
        this.classManageSearch.campusId = null;
      }
    },
    getTeacherTreeChange(item) {
      console.log(489, item);
      let length = item.length;
      let index = length;
      this.addForm.campusId = item[index - 1];
      this.getHeadTeacherList(item[index - 1]);
      this.getAcademicTeacherList(item[index - 1]);
    },
    //选择添加科目
    subjectIdChange() {
      if (this.searchForm.courseIds) {
        this.getClassInfoPhaseList(this.searchForm.courseIds[1]);
        this.classManageSearch.subjectCourseId = this.searchForm.courseIds[1];
        this.searchForm.classInfoPhase = null;
      } else {
        this.classManageSearch.subjectCourseId = null;
      }
    },
    subjectSearchChange() {
      // this.searchForm.subjectCourseId = this.courseIds[1];
      // addForm.courseIds
      this.api.classInfoPhase
        .getLastPhase({ subjectCourseId: this.addForm.courseIds[1] })
        .then((result) => {
          if (result.success) {
            this.addForm.classInfoPhase = result.data;
          } else {
            this.$message.error(result.message);
          }
        });
    },

    //获取全部校区
    // getCampusList() {
    //   this.api.campus.getCampusList().then(result => {
    //     if (result.success) {
    //       this.campusList = result.data;
    //       this.searchForm.campusId = this.campusList[0].id;
    //       this.getTree(this.searchForm.campusId);
    //     } else {
    //       this.$message.error(result.message);
    //     }
    //   });
    // },
    getCampusTree() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          if (result.success) {
            if (result.data.length == 0) {
              this.$message.error("暂无校区，请创建校区");
              this.loading = false;
              return;
            }
            for (let item of result.data) {
              if (item.children.length != 0) {
                for (let items of item.children) {
                  if (items.children.length != 0) {
                    for (let itemss of items.children) {
                      if (itemss.children.length != 0) {
                        delete itemss.children;
                      } else {
                        delete itemss.children;
                      }
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            if (result.data.length > 0) {
              this.campusList = result.data;
              // this.searchForm.campusId = result.data[0].id;
              // this.getTree(this.searchForm.campusId);
              // this.getHeadTeacherList(this.searchForm.campusId);
              // this.getAcademicTeacherList(this.searchForm.campusId);
              // this.getTeacherList(this.searchForm.campusId);
            }
            this.addForm.campusId = this.searchForm.campusId;
          } else {
            this.$message.error(result.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    yearMonthChange(val) {
      console.log(val);
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //签到距离
    // getSignLogList() {
    //   this.api.signLog.getSignLogList().then(result => {
    //     if (result.success) {
    //       this.signLogList = result.data;
    //     } else {
    //       this.$message.error(result.message);
    //     }
    //   });
    // },

    //获取班主任列表
    getHeadTeacherList(id) {
      // this.api.agentUserInfo.getHeadTeacherList({ campusId: id }).then(result => {
      //   if (result.success) {
      //     this.headTeacherList = result.data;
      //   } else {
      //     this.$message.error(result.message);
      //   }
      // });
      this.api.agentUserInfo.getTeacherListInfo().then((result) => {
        if (result.success) {
          this.headTeacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取教务老师列表
    getAcademicTeacherList(id) {
      return;
      this.api.agentUserInfo.getAcademicTeacherList({ campusId: id }).then((result) => {
        if (result.success) {
          this.academicTeacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取老师列表
    getTeacherList(id) {
      this.api.agentUserInfo.getTeacherList({ campusId: id }).then((result) => {
        if (result.success) {
        } else {
          this.$message.error(result.message);
        }
      });
    },

    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeListByAgentId()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取班级期数列表
    getClassInfoPhaseList(id) {
      return;
      let obj = {
        subjectCourseId: id,
      };
      if (this.searchForm.campusId) {
        obj.campusId = this.searchForm.campusId[2];
      }
      this.api.classInfoPhase.getClassInfoPhaseList(obj).then((result) => {
        if (result.success) {
          this.classInfoPhaseList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    //获取课程树
    getTree() {
      this.api.subjectCourse
        .getSubjectTreeList()
        .then((result) => {
          if (result.success) {
            for (let item of result.data) {
              if (item.children.length != 0) {
                for (let items of item.children) {
                  delete items.children;
                  // if (items.children.length != 0) {
                  //   for (let itemss of items.children) {
                  //     delete itemss.children;
                  //   }
                  // } else {
                  //   // delete items.children;
                  // }
                }
              } else {
                // delete item.children;
              }
            }
            this.ClassInfoTree = result.data;
            if (this.ClassInfoTree.length > 0) {
            } else {
              this.classManageList = [];
              this.$message.waring("该校区暂无科目课程");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;
      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:30px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.classManageSearch.pageNumber = 1;
      this.classManageSearch.type = val;
      this.pageList();
    },

    handleNodeClick(data) {
      if (this.clickTrue == true) {
        this.searchForm.courseId = data.id;
        this.pageList();
      } else {
      }
    },

    pageList() {
      this.loading = true;
      this.classManageSearch.headTeacher = this.searchForm.headTeacher;
      this.classManageSearch.name = this.searchForm.name;
      this.classManageSearch.phase = this.searchForm.classInfoPhase;
      this.classManageSearch.yearMonth = this.searchForm.yearMonth;
      this.classManageSearch.classroomName = this.searchForm.classroomName;
      this.classManageSearch.teacherName = this.searchForm.teacherName;
      this.classManageSearch.startDate = this.searchForm.startDate;
      this.classManageSearch.endDate = this.searchForm.endDate;
      this.classManageSearch.weekdays = this.searchForm.weekdays;
      this.classManageSearch.periods = this.searchForm.periods;
      this.classManageSearch.minNumber = this.searchForm.minNumber;
      this.classManageSearch.qqGroup = this.searchForm.qqGroup;
      this.classManageSearch.classInfoPhaseState = this.searchForm.classInfoPhaseState;
      let obj = JSON.parse(JSON.stringify(this.classManageSearch));
      let arr = [];
      if (this.searchForm.campusId && this.searchForm.campusId.length != 0) {
        this.searchForm.campusId.forEach((item) => {
          arr.push(item[item.length - 1]);
        });
        obj.campusIds = arr;
      }
      obj.campusId = undefined;
      this.api.classInfoPhase
        .pageList(obj)
        .then((result) => {
          this.classManageList = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
      // this.api.classInfo
      //   .pageList(this.classManageSearch)
      //   .then(result => {
      //     this.classManageList = result.data;
      //     this.loading = false;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },

    //添加班级
    addClassInfo() {
      if (this.addClassInfoBlock) {
        return false;
      }
      this.addClassInfoBlock = true;

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.subjectCourseId = this.addForm.courseIds[1];
          if(this.addForm.signDistance == '无签到要求'){
            this.addForm.signDistance = -1
          }
          this.addForm.signDistance = Number(this.addForm.signDistance);
          this.api.classInfoPhase.addClassInfoPhase(this.addForm).then((result) => {
            if (result.success) {
              this.classDialogVisible = false;
              this.$message.success(result.message);
              this.pageList();
              this.addClassInfoBlock = false;
            } else {
              this.$message.error(result.message);
              this.addClassInfoBlock = false;
            }
          });
        }
      });
    },

    goAddClass(data) {
      let ids = [];
      if (data) {
        let jump = data;
        ids.push(data.id);
        // if (result.success) {
        //   localStorage.setItem("classDetail", JSON.stringify([jump]));
        //   this.$router.push({ path: "/addClass" });
        // } else {
        //   this.$message.error(result.message);
        // }
      } else {
        if (this.multipleSelection.length > 0) {
          let ids = [];
          this.multipleSelection.forEach((res) => {
            ids.push(res.id);
          });
          this.api.classInfo
            .getClassInfoList({ classInfoPhaseIdList: ids })
            .then((result) => {
              if (result.success) {
                let jump = result.data;
                localStorage.setItem("classDetail", JSON.stringify(jump));
                localStorage.setItem("ids", JSON.stringify(ids));
                this.$router.push({ path: "/addClass" });
              } else {
                this.$message.error(result.message);
              }
            });
          // let jump = this.multipleSelection;
          // for (let item of jump) {
          //   ids.push(item.id);
          // }
          //   if (result.success) {
          //     localStorage.setItem("classDetail", JSON.stringify(jump));
          //     this.$router.push({ path: "/addClass" });
          //   } else {
          //     this.$message.error(result.message);
          //   }
        } else {
          this.$message.error("请选择需要批量排课的班级");
        }
      }
    },

    goClassSchedule() {
      this.$router.push({ path: "/classSchedule" });
    },

    goClassDetail(data) {
      // let jump = data;
      // localStorage.setItem("jump", JSON.stringify(jump));
      this.$router.push({ path: "/classDetail", query: { id: data.id } });
    },
    addCourse() {
      this.classDialogVisible = true;
      this.clickTrue = true;
    },

    classManageSizeChange(pageSize) {
      console.log("pageSize", pageSize);
      this.classManageSearch.pageSize = pageSize;
      this.pageList();
    },
    classManageCurrentChange(pageNumber) {
      console.log("pageNumber", pageNumber);
      this.classManageSearch.pageNumber = pageNumber;
      this.pageList();
    },

    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name == "first") {
        this.getChapterMaterialsList(this.courseIds, 1);
      }
      if (tab.name == "second") {
        this.getChapterMaterialsList(this.courseIds, 2);
      }
      if (tab.name == "third") {
        this.getChapterMaterialsList(this.courseIds, 3);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("this.multipleSelection", this.multipleSelection);
    },
    classStartDateChange(val) {
      if (val) {
        this.searchForm.startDate = val ? val[0] : "";
        this.searchForm.endDate = val ? val[1] : "";
      } else {
        delete this.searchForm.startDate;
        delete this.searchForm.endDate;
      }
    },
  },
  watch: {
    classDialogVisible(val) {
      if (!val) {
        this.getCampusTree();
        this.$refs.addForm.resetFields();
        this.addForm.minNumber = null;
        this.addForm.maxNumber = null;
        this.addForm.remark = "";
        this.addForm.classInfoPhase = "";
        this.addClassInfoBlock = false;
      }
    },
  },
  mounted() {
    this.getCampusTree();
    this.getTree();
    this.pageList();
    this.api.campus.getClassStartPeriod().then((res) => {
      this.classStartPeriodList = res.data;
    });
  },
};
</script>
<style scoped>
.classManage {
}
/* .classManage-left {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
} */
.classManage-right {
  /* padding: 20px; */
  /* padding: 0px 20px !important; */
}
.tab-type {
  padding: 20px;
  /* padding-top: 10px; */
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 40px;
  line-height: 40px;
}
.left-top-text {
  float: left;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
}
.classManage-search {
  padding: 0px 20px;
}
.classManage-select {
  width: 100%;
  margin-top: 20px;
}
.classManage-right-top {
  display: flex;
  padding: 20px;
}
.right-top-type {
  height: 20px;
  width: 50px;
  background-color: #24d2b5;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-left: 20px;
}
.right-top-text {
  font-size: 16px;
  font-weight: 700;
}
.basicInformation {
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 20px;
  font-size: 13px;
}
.classInformation {
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 20px;
  font-size: 13px;
  margin-top: 20px;
}
.classManage-icon {
  float: right;
  font-size: 16px;
  margin-left: 20px;
}
.classManage-study1 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  margin-top: 2px;
  border-left: 2px solid #a2aabc;
  background-color: rgba(162, 170, 188, 0.0980392156862745);
}
.classManage-study2 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  margin-top: 2px;
  border-left: 2px solid rgba(77, 148, 255, 1);
  background-color: rgba(77, 148, 255, 0.0980392156862745);
}
.classManage-study3 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ffc349;
  margin-top: 2px;
  border-left: 2px solid rgba(255, 195, 73, 1);
  background-color: rgba(162, 170, 188, 0.0980392156862745);
}
.classManage-study4 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ff5555;
  margin-top: 2px;
  border-left: 2px solid rgba(255, 85, 85, 1);
  background-color: rgba(255, 85, 85, 0.0980392156862745);
}
.tree-class1 {
  background-color: #ffc349;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}
.tree-class2 {
  background-color: rgba(36, 210, 181, 1);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}
.tree-class3 {
  background-color: #a2aabc;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}
.tree-class4 {
  background-color: rgb(250, 3, 36);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}
.classManage-classList {
  margin-top: 20px;
  margin-bottom: 20px;
}
.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}
.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}
.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
.style4 {
  background: rgb(250, 3, 36);
  border: solid 1px rgb(250, 3, 36);
}
</style>
<style lang="less">
.classManage {
  // .el-form-item {
  //   margin-bottom: 0px;
  // }
  .el-form-item__label {
    line-height: 30px;
    font-size: 13px !important;
    font-weight: 400;
    color: #455a64;
  }
  .el-form-item__content {
    line-height: 30px;
    font-size: 13px !important;
  }
  .el-tabs__nav {
    margin-left: 20px;
  }
  .classManage-tree {
    margin-top: 10px;
    .el-tree-node__label {
      font-size: 13px;
      color: #a2aabc;
    }
  }
}
.el-popper {
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/classManage/index.vue